<h1 mat-dialog-title>Tier bearbeiten</h1>
<div mat-dialog-content class="tier-edit-dialog-content">
    <div class="tier-edit-dialog-header">
        <p>
            <strong>Ohrmarke:</strong>
            <kiene-ohrmarke [ohrmarke]="this.tier.ohrmarke_notnull"></kiene-ohrmarke>
        </p>
    </div>

    <mat-form-field class="no-padding-margin-mat-form-field tier-edit-field">
        <mat-label>Abteil</mat-label>
        <input matInput [placeholder]="'Abteil'" [formControl]="abteilCtrl" />
    </mat-form-field>

    <div class="tier-edit-haendler-row">
        <mat-form-field class="no-padding-margin-mat-form-field tier-edit-field">
            <mat-label>H&auml;ndler ausw&auml;hlen</mat-label>
            <mat-select [compareWith]="compareHaendler" [formControl]="haendlerCtrl">
                <mat-option *ngFor="let haendler of haendlerFavoriten" [value]="haendler">{{
                    haendler.name
                }}</mat-option>
            </mat-select>
            <mat-hint style="padding-top: 24px" *ngIf="emptyListHaendler">
                Es ist kein H&auml;ndler gespeichert. Ggf. über das + Symbol einen H&auml;ndler hinzufügen.
            </mat-hint>
        </mat-form-field>
        <button
            (click)="openHaendlerVerwaltung()"
            mat-icon-button
            color="accent"
            [disabled]="!canEditHaendler"
            class="tier-edit-haendler-add"
        >
            <mat-icon>add</mat-icon>
        </button>
    </div>
</div>
<div mat-dialog-actions class="tier-edit-dialog-actions">
    <button (click)="dialogRef.close()" mat-flat-button>Abbrechen</button>
    <button (click)="updateGruppeTier()" mat-flat-button color="accent">Speichern</button>
</div>
